import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Label} from '@/components/ui/label/Label'
import {RadioBoxItem} from '@/components/ui/radio-box-atoms/RadioBoxAtoms'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {projectAssistiveRegimeToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {ObjectKeys} from '@/utilities/helpers'
import {Root} from '@radix-ui/react-toggle-group'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectCareSubRegimeOutpatientSchema = ProjectFieldsSchema.pick({
    patient: true,
    assistiveRegime: true
})
type ProjectCareSubRegimeOutpatientSchema = z.infer<typeof ProjectCareSubRegimeOutpatientSchema>

export const ProjectCareSubRegimeOutpatient = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectCareSubRegimeOutpatientSchema>()
    const {field, fieldState} = useController({control, name: 'assistiveRegime'})
    const serviceType = useWatch({control, name: 'patient.serviceType'})

    return (
        <GridItem spanColumn={2} direction="column" gap={1.5} fullWidth>
            <Label>{t('commons:care_sub_regime')}</Label>
            <Root
                type="single"
                value={field.value?.toString() ?? ''}
                onValueChange={value => field.onChange(value || null)}
                style={{width: '100%'}}
            >
                <Grid columns={2} gap={4} fullWidth>
                    {ObjectKeys(projectAssistiveRegimeToLabel)
                        .filter(key => {
                            if (serviceType == 'evolutionary_age') return key != 'adults'
                            if (serviceType == 'adults') return key != 'minors'
                            return true
                        })
                        .map(key => (
                            <GridItem fullWidth key={key}>
                                <RadioBoxItem name={field.name} value={key} error={!!fieldState.error?.message}>
                                    {t(projectAssistiveRegimeToLabel[key])}
                                </RadioBoxItem>
                            </GridItem>
                        ))}
                </Grid>
            </Root>
        </GridItem>
    )
}
